import {
  THONGKETHEGIO_COUNT_ASSIGN_SUCCESS,
  THONGKETHEGIO_HISTORY_LIST_SUCCESS,
  THONGKETHEGIO_IMPORT_SUCCESS,
  THONGKETHEGIO_LIST_SUCCESS,
  THONGKETHEGIO_NEW_CARE_SUCCESS,
  THONGKETHEGIO_ONE_SUCCESS,
  THONGKETHEGIO_UPDATE_FILTER,
  THONGKETHEGIOCOMLIST_LIST_SUCCESS,
} from 'src/actions/thongkethegio.action';
import { LOOKUP_CLEANER } from 'src/actions/lookup.action';

import {
  DEFAULT_ROW_PER_PAGE,
} from 'src/utils/constants';

import dayjs from 'dayjs';

const today = new Date();

const initState = {
  filter: {
    message: '',
    startDate: dayjs(new Date(today.getFullYear(), today.getMonth(), 1)),
    endDate: dayjs(today),
    page: 0,
    limit: DEFAULT_ROW_PER_PAGE,
  },
  items: [],
  total: 0,
  thongkethegiocomlist_items: [],
  thongkethegiocomlist_total: 0,
  temp: [],
  selected: undefined,
  countAssign: 0,
  history: [],
  totalHistory: 0,
  newCare: undefined,
  canCare: 0
}

const thongkethegioReducer = (state = initState, action) => {
  switch (action.type) {
    case THONGKETHEGIO_UPDATE_FILTER:  {
      if (action.data && typeof action.data !== 'undefined' && action.data && typeof state.filter !== 'undefined' && state.filter) {
        if (action.data.page == 'no_update' && typeof state.filter.page !== 'undefined') action.data.page = state.filter.page;
        if (action.data.limit == 'no_update' && typeof state.filter.limit !== 'undefined') action.data.limit = state.filter.limit;
      }
      return {
        ...state,
        filter: action.data,
      }
    }
    case THONGKETHEGIOCOMLIST_LIST_SUCCESS: {
      console.log({
        thongkethegiocomlist_items: action.data.items,
        thongkethegiocomlist_total: action.data.total,
      })
      return {
        ...state,
        thongkethegiocomlist_items: action.data.items,
        thongkethegiocomlist_total: action.data.total,
      }
    }
    case THONGKETHEGIO_LIST_SUCCESS: {
      return {
        ...state,
        items: action.data.items,
        total: action.data.total,
        tong_nap: action.data.tong_nap, 
        thuc_nhan: action.data.thuc_nhan, 
        so_the_dung: action.data.so_the_dung, 
        so_the_sai: action.data.so_the_sai,
      }
    }
    case THONGKETHEGIO_ONE_SUCCESS: {
      return {
        ...state,
        selected: action.data
      }
    }
    case THONGKETHEGIO_NEW_CARE_SUCCESS: {
      return {
        ...state,
        newCare: action.data.newCare,
        canCare: action.data.canCare,
      }
    }
    case THONGKETHEGIO_IMPORT_SUCCESS: {
      return {
        ...state,
        temp: action.data,
      }
    }
    case THONGKETHEGIO_COUNT_ASSIGN_SUCCESS: {
      return {
        ...state,
        countAssign: action.data,
      }
    }
    case THONGKETHEGIO_HISTORY_LIST_SUCCESS: {
      return {
        ...state,
        history: action.data.items,
        totalHistory: action.data.total,
      }
    }
    case LOOKUP_CLEANER: {
      return initState
    }
    default: {
      return state;
    }
  }
}
export default thongkethegioReducer